import { useLocation, Link } from 'react-router-dom';
import { Platform, View, Text } from 'react-native';
import styles from './Menus.styles';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import { stdCouleurBleu, stdCouleurRougeClair } from '@commonStyle';
import { MenuMobileProps } from '../Layout.types';



export default function MenuMobile({menuItems}: MenuMobileProps){
  const location = useLocation();
  const webBarStyle = Platform.OS === 'web'
  ? ({ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 1000 } as any)
  : {};

  return (
    <View
    style={[
    styles.tabBar,
    webBarStyle,
  ]}>
      {menuItems.filter(tab => tab.tabs).map((menuItem) => (
        <Link key={menuItem.path} to={menuItem.path} style={styles.tabLink}>
          <View style={[
            styles.tab,
            location.pathname === menuItem.path && styles.activeTab
          ]}>
            <MaterialCommunityIcons
              name={menuItem.icon}
              color={location.pathname === menuItem.path ? stdCouleurRougeClair : stdCouleurBleu}
              size={20}
            />
            <Text style={[
              styles.tabText,
              location.pathname === menuItem.path && styles.activeTabText
            ]}>
              {menuItem.label}
            </Text>
          </View>
        </Link>
      ))}
    </View>
  );
};
